<mat-spinner *ngIf="isLoadingProjectsList" [diameter]="11" class="margin-spinner"></mat-spinner>

<span
	*ngIf="
		!utilService.isNullOrUndefined(projects) && !utilService.isNullOrUndefined(carrierToProjectsMap)
	"
>
	<span
		#popoverTrigger="mtxPopoverTrigger"
		(click)="$event.stopPropagation()"
		[mtxPopoverTriggerFor]="projectsPopover"
		class="cursor-pointer"
		mtxPopoverTriggerOn="click"
	>
		<span *ngIf="projects.length > 0" class="dropdown" fxLayoutAlign="center center">
			{{ projects.length }} {{ projects.length > 1 ? 'Projects' : 'Project' }}
			<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">assignment</mat-icon>
		</span>
		<span *ngIf="projects.length == 0" class="dropdown" fxLayoutAlign="center center">
			<span class="text-underline primary-text">Add to Project</span>
			<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">keyboard_arrow_down</mat-icon>
		</span>
	</span>

	<mtx-popover
		#projectsPopover="mtxPopover"
		(close)="projectsLimit = 10; nextPage = true"
		[closeOnPanelClick]="false"
	>
		<mat-card [ngClass]="{ 'projects-dropdown-border': isCarrierSearch }" id="projectsPopover">
			<mat-card-header>
				<mat-form-field fxFlex="80">
					<input
						[(ngModel)]="searchText"
						(ngModelChange)="onSearchTextChange($event)"
						autocomplete="off"
						matInput
						placeholder="Type to filter"
					/>
				</mat-form-field>
			</mat-card-header>

			<mat-card-content class="projects-dropdown">
				<div class="padding-0-5" fxLayout="row">
					<app-project-dialog
						(updatedData)="reloadList.emit($event)"
						[addProjectLink]="true"
						[addProject]="true"
						[carrierIDs]="carrierIDs"
						[projectSource]="projectSource"
						[searchTruckForm]="searchTruckForm"
					>
					</app-project-dialog>
				</div>
				<div *ngIf="carrierToProjectsMap.length === 0" class="primary-text">
					No Projects Available
				</div>
				<div
					*ngFor="
						let project of carrierToProjectsMap
							| search : 'projectName' : searchText
							| slice : 0 : projectsLimit;
						let i = index
					"
					class="padding-0-5"
					fxLayout="row"
				>
					<div fxFlex="25" fxLayoutAlign="start center">
						<mat-slide-toggle
							#slideToggleRef
							(change)="projectToggled(project, $event.checked, slideToggleRef)"
							[checked]="project.isCarrierMappedToProject"
							[color]="'primary'"
						>
						</mat-slide-toggle>
					</div>
					<div class="primary-text font-size-vw" fxFlex fxLayoutAlign="start center">
						{{ project.projectName }}
					</div>
				</div>
			</mat-card-content>
			<mat-divider
				*ngIf="
					nextPage &&
					(totalNumberOfProjects != carrierToProjectsMap.length ||
						projectsLimit < carrierToProjectsMap.length)
				"
			></mat-divider>

			<mat-card-actions
				*ngIf="
					nextPage &&
					(totalNumberOfProjects != carrierToProjectsMap.length ||
						projectsLimit < carrierToProjectsMap.length)
				"
				fxLayoutAlign="end center"
			>
				<span
					(click)="viewMoreProjects()"
					*ngIf="!isLoadingProjectsList"
					class="text-underline primary-text cursor-pointer"
				>
					View More
				</span>
				<mat-spinner *ngIf="isLoadingProjectsList" [diameter]="30"></mat-spinner>
			</mat-card-actions>
		</mat-card>
	</mtx-popover>
</span>
